<script setup>
import { computed, provide } from 'vue'
import { DropdownMenuRoot, useForwardPropsEmits } from 'radix-vue'
import { DROPDOWN_DIRECTION } from '@shared/constants/bootstrap'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  class: { type: null, required: false },
  defaultOpen: { type: Boolean, required: false },
  open: { type: Boolean, required: false },
  dir: { type: String, required: false },
  modal: { type: Boolean, required: false },
  direction: {
    type: String,
    required: false,
    validator: (val) => ['top', 'left', 'right', 'bottom'].includes(val),
  },
})
const emits = defineEmits(['update:open'])

provide('dropdownMenu', {
  direction: props.direction,
})

const delegatedProps = computed(() => {
  const { class: _, direction, ...delegated } = props
  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <DropdownMenuRoot v-bind="forwarded">
    <div :class="['btn-group', props.class, DROPDOWN_DIRECTION[props.direction]]">
      <slot />
    </div>
  </DropdownMenuRoot>
</template>
